"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    userId: zod_1.z.number(),
});
exports.path = '/admin-deactivate-user';
//# sourceMappingURL=index.js.map